import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base, Fee } from '@/models';
import { toCamelCase, omitDeep, datetimeToUTC } from '@/utilities';

export class Invoice extends Base {
  public invdate: string;
  public invid: string;
  public invfor: string;
  public description: string;
  public fees:  Fee[];

  public constructor(data?: Partial<Invoice>) {
    super(data);
    data = toCamelCase(data);
    this.invdate = _get(data, 'invdate', "");
    this.invid = _get(data, 'invid', '');
    this.invfor = _get(data, 'invfor', '');
    this.description = _get(data, 'description', '');
    this.fees = _castArray(_get(data, 'fees', [])).map((x: Partial<Fee>) => new Fee(x));
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
  public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID
    return {
      ...json,
    };
  }

}
